import React, { useRef, useState } from "react";
import {
  Avatar,
  ClickAwayListener,
  Grow,
  MenuItem,
  MenuList,
  Paper,
  Popper,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

const AvatarDiv = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  "& span": {
    color: theme.palette.primary.light,
    fontSize: "18px",
    marginRight: "10px",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
}));

export default function UserMenu() {
  const navigate = useNavigate();
  const anchorRef = useRef(null);
  const [openPopper, setOpenPopper] = useState(false);

  const loginData = localStorage.getItem("user");
  const loginValue = JSON.parse(loginData);

  const handleLogout = () => {
    localStorage.clear();
    setOpenPopper(false);
    navigate("/login");
  };

  const handlePopperOpen = () => {
    setOpenPopper((prev) => !prev);
  };

  const handleClosePopper = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpenPopper(false);
  };

  const handleListKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpenPopper(false);
    } else if (event.key === "Escape") {
      setOpenPopper(false);
    }
  };

  return (
    <AvatarDiv>
      <span>{loginValue.full_name}</span>
      <Avatar
        alt={loginValue.full_name}
        sx={{
          width: 43,
          height: 43,
          cursor: "pointer",
          border: `2px solid #fafafa`,
        }}
        onClick={handlePopperOpen}
        ref={anchorRef}
      />

      <Popper
        open={openPopper}
        anchorEl={anchorRef.current}
        role={undefined}
        placement="bottom-start"
        transition
        disablePortal
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin:
                placement === "bottom-start" ? "left top" : "left bottom",
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClosePopper}>
                <MenuList
                  autoFocusItem={openPopper}
                  id="composition-menu"
                  aria-labelledby="composition-button"
                  onKeyDown={handleListKeyDown}
                >
                  <MenuItem onClick={handleLogout}>Logout</MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </AvatarDiv>
  );
}
